import { render, staticRenderFns } from "./ColorPresets.vue?vue&type=template&id=52301b9a&scoped=true&"
import script from "./ColorPresets.vue?vue&type=script&lang=js&"
export * from "./ColorPresets.vue?vue&type=script&lang=js&"
import style0 from "./ColorPresets.vue?vue&type=style&index=0&id=52301b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52301b9a",
  null
  
)

export default component.exports